<template>
  <base-dialog-button 
    :isOpen="dialogOpen" 
    @closeDialog="toggleDialog" 
    :size="mobileVersion ? 'fs' : 'fs-space'" 
    :closable="false" 
    forzeHFull
    :ariaLabel="$t('wizard.header')" 
    refNameContainer="baseDialogContainerWizard">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('wizard.header')}}</h2>
        </div>
      </div>
    </template>
    <template slot="main">
      <div class="w-full flex flex-col min-h-full dark:bg-staticdarkblue-900"
        style="height: calc(100vh - 500px)">
        <div class="flex h-full overflow-hidden relative mt-6">
          <div class="content-wrapper w-full flex flex-col overflow-hidden relative">
            <div class="flex-none relative" v-if="activeStep !== 1 && !isLower1024">
              <!-- <h2 class="dark:text-staticdarkblue-200 text-md mb-4 text-center">{{$t('wizard.header')}}</h2> -->
              <el-steps :active="activeStepStepper" finish-status="success" align-center class="mb-2 static-css pl-4 mr-4">
                <el-step v-if="listaSteps.includes(1)" :title="$t('wizard.step_inicial_title')" icon="el-icon-video-play"></el-step>
                <el-step v-if="listaSteps.includes(2)" :title="$t('wizard.step_descarga_automatica_title')" icon="el-icon-download"></el-step>
                <el-step v-if="listaSteps.includes(3)" :title="$t('wizard.step_sede_judicial_title')" icon="el-icon-school"></el-step>
                <el-step v-if="listaSteps.includes(4)" :title="$t('wizard.step_certs_title')" icon="el-icon-office-building"></el-step>
                <el-step v-if="listaSteps.includes(5)" :title="$t('wizard.step_tutorial_title')" icon="el-icon-video-play"></el-step> 
                <el-step v-if="listaSteps.includes(6)" :title="$t('wizard.step_end')" icon="el-icon-circle-check"></el-step>
              </el-steps>
            </div>
            <div class="content relative flex flex-col flex-initial overflow-y-auto w-full" id="container-steps">
              
              <!-- <div class="m-6 border-2 rounded h-full p-2"> -->
                <div class="ml-8 lg:ml-16 mr-8 lg:mr-16 p-2 form-wrapper">

                  <div v-if="activeStep === 1" class="flex flex-col items-center">
                    <base-logo :filename="logo" alt="EdasNEO" class="mx-auto mb-6 w-logo brand"/>
                    <h2 class="dark:text-darkblue-200 font-bold p-4 mb-4 text-4xl text-balance text-center">{{$t('wizard.step_beginning')}}</h2>
                    <label class="text-xl font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-center text-balance">
                      {{$t('wizard.beginning_msg')}}
                    </label>
                    <base-button
                      @click="nextStep" 
                      class="mt-4"
                      mode="primary" 
                      text="Empezar configuración" 
                      :loading="isGeneralLoading" 
                      :disabled="isGeneralLoading" 
                      />
                  </div>

                  <div v-if="activeStep === 2">

                    <el-form
                      :model="formStepDescargaAutomatica"
                      :rules="rulesStepDescargaAutomatica"
                      ref="ruleformStepDescargaAutomatica"
                    >
                      <h2 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('wizard.step_descarga_automatica')}}</h2>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 text-sm">
                        {{$t('wizard.step_descarga_automatica_msg_1')}}
                      </label>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-6 text-sm">
                        {{$t('wizard.step_descarga_automatica_msg_3')}}
                      </label>
                        <div class="mb-6">
                          <div class="mandatory">
                            <label for="id-switch-wizard-descarga" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                              {{$t('companies.automatic_download_active')}}
                              <span class="sr-only">{{$t('app.options')}}: {{$t('companies.inactive')}} / {{$t('companies.active')}}</span>
                            </label>
                            <el-switch 
                              id="id-switch-wizard-descarga"
                              :aria-label="$t('companies.automatic_download_active')"
                              class="switch-text break-normal mt-2" 
                              v-model="formStepDescargaAutomatica.DescargaAutomatica"
                              :active-text="$t('companies.active')">
                            </el-switch>
                          </div>
                        </div>
                        <div class="lg:mb-2 max-w-[500px]" v-if="formStepDescargaAutomatica.DescargaAutomatica">
                          <div class="mandatory">
                            <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('companies.automatic_download_days_label')}}
                              <el-form-item prop="DiasDescargaAutomatica">
                                <el-input
                                  clearable
                                  class="w-full"
                                  v-model="formStepDescargaAutomatica.DiasDescargaAutomatica"
                                  maxlength='5'
                                />
                              </el-form-item>
                            </label>
                          </div>
                        </div>
                        <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 text-sm" v-if="formStepDescargaAutomatica.DescargaAutomatica">
                          {{$t('wizard.step_descarga_automatica_msg_2')}}
                        </label>

                    </el-form>
                  </div>

                  <div v-if="activeStep === 3">
                    <el-form
                      :model="formStepSedeJudicial"
                      :rules="rulesStepSedeJudicial"
                      ref="ruleformStepSedeJudicial"
                    >
                      <h2 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('wizard.step_sede_judicial')}}</h2>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.step_sede_judicial_msg_1')}}
                      </label>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.step_sede_judicial_msg_2')}}
                      </label>

                      <div class="lg:mb-2 max-w-[500px]">
                        <div class="mandatory">
                          <AccessibleElSelect
                            v-model="formStepSedeJudicial.idSedeJudicial"
                            prop="idSedeJudicial"
                            :options="sedesJudicialesForAccessibleSelect"
                            :withFormItem="true"
                            id-prefix="wizarddialog"
                          >
                            <template slot="label"><base-obligatory-icon/>{{$t('wizard.step_sede_judicial_title_2')}}</template>
                          </AccessibleElSelect>
                        </div>
                      </div>


                    </el-form>
                  </div>

                  <div v-if="activeStep === 4">
                    <el-form
                      :model="formStepCertificados"
                      :rules="rulesStepCertificados"
                      ref="ruleformStepCertificados"
                    >
                      <h2 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('wizard.step_certs')}}</h2>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-1 text-sm">
                        {{$t('wizard.step_certs_msg_1')}}
                      </label>
                      <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                        {{$t('wizard.step_certs_msg_2')}}
                      </label>
                      <div class="w-full flex lg:flex-row flex-col gap-x-6 ">
                        <div v-for="(certificadoCIF, key) in formStepCertificados.certificadosCIFs" :key="key" 
                          class="block w-full lg:mb-0 mb-6"
                          :class="[
                            (dataCertificates.length < 2 && !isLower1024)? 'max-w-[50%]' : '', 
                            showButtonNextForm(key) ? '' : 'rounded border-2'
                          ]"
                          > 
                          <div class="flex w-full" 
                            v-if="showButtonNextForm(key)"
                            >
                            <base-button 
                              @click.stop.prevent="onClickAddForm" 
                              mode="secondary-phantom-blue" 
                              :text="$t('configurations.add_other_certificate')" 
                              :loading="isGeneralLoading" 
                              :disabled="isGeneralLoading" /> 
                          </div>
                          <div v-else>
                            <div class="flex items-center justify-between">
                              <h2 class="dark:text-darkblue-200 font-bold text-secondary-600 p-4"><base-obligatory-icon v-if="key === 0"/>{{'Certificado y empresa ' + (key + 1)}}</h2>
                              <base-button-icon
                                v-if="checkPreloadCert(key)"
                                @click.stop.prevent="resetCertForm(key)" 
                                ariaLabel="Eliminar certificado"
                                name="cross"
                                mode="secondary-phantom-blue"
                                class="mr-2"
                                custom="dark:border dark:border-darkblue-600"
                                :disabled="isGeneralLoading" />
                            </div>

                            <hr class="border"/>
                            <div class="flex flex-col gap-x-6 w-full pl-4 pr-4 pt-2" v-if="!checkPreloadCert(key) && isNextPreloadAvailable(key)">
                              <div class="lg:mb-2 flex flex-col w-full">
                                <div>
                                  <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon v-if="key === 0"/>{{$t('app.cert_pfx')}}</label>
                                  <el-form-item 
                                    class="!mb-0"
                                    :prop="'certificadosCIFs.'+ key + '.file'" 
                                    :ref="'certificadosCIFs'+ key + 'file'"
                                    :rules="rulesStepCertificados.file"
                                    >
                                    <Upload
                                      role="button"
                                      :ref="'certificadosCIFs'+ key + 'upload'"
                                      accept=".pfx,.p12"
                                      :id="'certificadosCIFs.'+ key + '.pfxselector'"
                                      class="bg-white dark:bg-darkblue-900 custom-upload-xs"
                                      :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload']"
                                      drag
                                      action="#"
                                      :show-file-list="false"
                                      :multiple="false"
                                      :auto-upload=false
                                      :on-change="(file) => handleChange(file, key)">
                                      <i class="el-icon-upload"></i>
                                      <p v-if="files[key].name" class="el-upload__text"><em>{{files[key].name}}</em></p>
                                      <div v-else class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
                                    </Upload>
                                  </el-form-item>
                                </div>
                                <div class="w-full flex items-center gap-x-2" v-if="files[key].name">
                                  <div class="w-full">
                                    <label class="text-sm font-semibold text-secondary-600 block w-full"><base-obligatory-icon v-if="key === 0"/>{{$t('certificates.password')}}</label>
                                    <el-form-item :prop="'certificadosCIFs.'+ key + '.password'"
                                      :rules="rulesStepCertificados.password"
                                      >
                                      <el-input
                                        clearable
                                        show-password
                                        autocomplete="new-password"
                                        class="w-full"
                                        v-model="formStepCertificados.certificadosCIFs[key].password"
                                        maxlength='255'
                                      />
                                    </el-form-item>
                                  </div>
                                  <base-button 
                                    @click.stop.prevent="nextStepValidate(key)" 
                                    mode="secondary-phantom-blue" 
                                    :text="labelValidate" 
                                    :loading="isGeneralLoading" 
                                    :disabled="isGeneralLoading" />
                                </div>
                              </div>
                            </div>
                            <div class="flex flex-col gap-x-6 w-full pr-4 pt-2 pl-4" v-if="checkPreloadCert(key)">
                              <div class="w-full">
                                <base-ro-input-wrap :label="$t('certificates.name')" :data="dataCertificates[key].nombre" class="mb-2"/>
                                <div class="flex gap-x-6 lg:flex-row flex-col">
                                  <base-ro-input-wrap :label="$t('certificates.issuer')" :data="dataCertificates[key].issuer" class="mb-2 w-full"/>
                                  <base-ro-input-wrap :label="$t('certificates.expires_at')" :data="dataCertificates[key].fechaCaducidad" class="mb-2 w-full"/>
                                </div>
                              </div>
                              <div class="w-full flex flex-col justify-center">
                                <div class="flex gap-x-6 lg:flex-row flex-col">
                                  <div class="w-full">
                                    <div class="mandatory">
                                      <label class="text-sm font-semibold text-secondary-600 block mb-2"><base-obligatory-icon/>{{$t('companies.cif')}}
                                        <el-form-item :prop="'certificadosCIFs.'+ key + '.CIF'"
                                          :rules="rulesStepCertificados.general"
                                          >
                                          <el-input
                                            clearable
                                            class="w-full"
                                            v-model="formStepCertificados.certificadosCIFs[key].CIF"
                                            maxlength='50'
                                          />
                                        </el-form-item>
                                      </label>
                                    </div>
                                  </div>
                                  <div class="w-full">
                                    <div class="mandatory">
                                      <label class="text-sm font-semibold text-secondary-600 block mb-2"><base-obligatory-icon/>{{$t('companies.companyName')}}
                                        <el-form-item :prop="'certificadosCIFs.'+ key + '.NombreCIF'"
                                          :rules="rulesStepCertificados.general"
                                          >
                                          <el-input
                                            clearable
                                            class="w-full"
                                            v-model="formStepCertificados.certificadosCIFs[key].NombreCIF"
                                            maxlength='150'
                                          />
                                        </el-form-item>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                        
                    </el-form>
                  </div>

                  <div v-if="activeStep === 5">
                    <h2 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('wizard.step_tutorial')}}</h2>
                    <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                      {{$t('wizard.step_tutorial_msg')}}
                    </label>
                    <div class="flex flex-col items-center w-full">
                      <accessible-video
                        v-if="videoIdLink"
                        :key="videoIdLink"
                        id="wizard-tutorial"
                        :youtube-id="videoIdLink"
                        :title="$t('wizard.step_tutorial')"
                        class="mb-2 flex flex-col"
                        :active="true"
                        :style="{ maxWidth: '100%', width: '400px' }"
                      />
                    </div>
                  </div>

                  <div v-if="activeStep === lastStep">
                    <h2 class="dark:text-darkblue-200 font-bold mt-2 mb-4">{{$t('wizard.step_end')}}</h2>
                    <label class="font-semibold text-secondary-600 dark:text-darkblue-200 block mb-4 text-sm">
                      {{$t('wizard.end_msg')}}
                    </label>
                  </div>

                </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="flex space-x-2 px-2 bg-white py-1 mt-auto dark:bg-darkblue-900 justify-between w-full items-center">
        <base-button-responsive @click="logout" mode="secondary-phantom-blue" icon="logout" :text="$t('app.exit')" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
        <div class="flex">
          <base-button-responsive v-if="!desactiveBackStep" @click="backStep" mode="secondary-phantom-blue" icon="chevronleft" :text="labelBackStep" class="mr-2" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button-responsive v-if="enableNextStep" @click="nextStep" mode="secondary-phantom-blue" icon="chevronright" :text="labelNextStep" class="mr-2" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button-responsive v-if="desactiveNextStep" @click="finishStep" mode="secondary-phantom-blue" icon="check" :text="$t('wizard.finish_step')" class="mr-2" :loading="isGeneralLoading" :disabled="isGeneralLoading" />
        </div>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import moment from 'moment'
import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'

// Step Aux
import { updateStepWizard } from '@/services/wizard/updateStepWizard' 

// Step Descarga automatica
import { getCompanyTemplate } from '@/services/app/getCompanyTemplate' 
import { updateDescargaAutomaticaWizard } from '@/services/wizard/updateDescargaAutomaticaWizard' 

// Step Sedes judiciales
import { TIPOS_SEDES_JUDICIALES } from '@/config/tipos-sedes-judiciales'
import { getSedeJudicialWizard } from '@/services/wizard/getSedeJudicialWizard' 
import { updateSedeJudicialWizard } from '@/services/wizard/updateSedeJudicialWizard' 

// Step Certificados
import { getPfxData } from '@/services/wizard/getPfxData'  
import { getCertData } from '@/services/wizard/getCertData' 

import { uploadPfx } from '@/services/wizard/uploadPfx' 

// Step Tutorial
import { getVideoTutorial } from '@/services/wizard/getVideoTutorial'  

import BaseDialogButton from '../base/BaseDialogButton.vue'
import BaseObligatoryIcon from '../base/BaseObligatoryIcon.vue'
import AccessibleVideo from '@/components/AccessibleVideo.vue'
import { Upload } from 'element-ui'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

function isValidEmail (value) {
  return emailRegex.test(value)
}
function isPhoneValid (value) {
  var onlyNumbers = /^\d+$/
  return onlyNumbers.test(value)
}
function isValidDayDownload (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 10) {
      return true
    }
  }
  return false
}

export default
{
  name: 'wizard-dialog',
  components: {
    BaseDialogButton,
    Upload,
    BaseObligatoryIcon,
    AccessibleElSelect,
    AccessibleVideo,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    dataWizard: {
      default: null
    }
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      isLoadedData: false,
      licenseReaded: false,

      videoIdLink: null,
      // Steps
      activeStep: 0,
      lastStep: 0,

      formStepDescargaAutomatica: {
        DescargaAutomatica: false,
        DiasDescargaAutomatica: null,
      },

      sedesJudiciales: TIPOS_SEDES_JUDICIALES,
      formStepSedeJudicial: {
        idSedeJudicial: null,
      },

      formStepCertificados: {
        certificadosCIFs: [
          {
            password: null,
            file: '',
            NombreCIF: '',
            CIF: '',
          },
        ],
      },
      
      // Fuerza a no mostrar el formulario del siguiente certificado
      showNextForm: false,

      // Aux Step 3
      files: [
        {
          name: '',
          b64: ''
        },
      ],

      // Aux Step 3
      dataCertificates: [
        {
          issuer: '',
          nombre: '',
          fechaCaducidad: '',
          serial: '',
        },
      ],

      rulesStepSedeJudicial: {
        idSedeJudicial: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
      },

      
      rulesStepDescargaAutomatica: {
        DiasDescargaAutomatica: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isDayValidDownload, trigger: 'blur' }
        ],
      },

      // Reglas finales dinámicas del Step de Certificados
      rulesStepCertificados: {},

      rulesStepCertificadosCert: {
        password: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        file: [
          {
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const key = rule.field.match(/\.(\d+)\./)[1]

              if (!this.files[key].name) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
              } else {
                callback()
              }
            }
          },
          {
            message: this.$i18n.t('validation.not_pfx'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              const key = rule.field.match(/\.(\d+)\./)[1]
              if (!this.files[key].name || 
                this.files[key].name.length < 5 || 
                !['.PFX', '.P12'].includes(this.files[key].name.substr(this.files[key].name.length - 4).toUpperCase())) {
                this.doAriaLiveAndReturnCallback(i18n.t('validation.not_pdf'), callback)
              } else {
                callback()
              }
            }
          }
        ],
      },

      rulesStepCertificadosSubmit: {
        general: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      },
    }
  },
  mounted: async function () {
    this.isLoadedData = false
    this.isLoadedData = true
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.activeStep = this.dataWizard?.CurrentStep
        this.lastStep = this.dataWizard?.ListaSteps[this.dataWizard?.ListaSteps.length -1]
      } 
    },
    // Control de carga inicial
    activeStep: async function (value, oldValue) {
      if (value === 2) {
        const data = await this.downloadDataStepDescargaAutomatica()
        this.setDataStepDescargaAutomatica(data.respuesta)
      } else if (value === 3) {
        const data = await this.downloadDataStepDescargaAutomaticaSedesJudiciales()
        this.setDataStepSedesJudiciales(data.respuesta)
      } else if (value === 4) {
        // Reseteams form y añadimos el primero objeto, que es obligatorio
        this.cleanDataStepCerts()
        this.pushDataStepCerts()
        // Descargamos datos
        const data = await this.downloadDataStepCerts()
        // Si hay algun dato añadimos un segundo formulario y ocultamos el ultimo
        if (data.respuesta.length > 0) {
          this.showNextForm = false
          this.pushDataStepCerts()
          // Si son dos añadimos el tercero
          if (data.respuesta.length >= 2) this.pushDataStepCerts()
          // Si son 3 mostramos el ultimo
          if (data.respuesta.length === 3) this.showNextForm = true
        }
        // Rellenamos todos los formularios
        data.respuesta.forEach((element, index) => {
          element.datosCertificadoVinculado = {
            ExpirationDate: element.ExpirationDate,
            CommonName: element.CommonName,
            SerialNumber: element.SerialNumber,
          }
          this.setDataStepCerts(element, index)
        })
      } else if (value === 5) {
        const data = await this.downloadDataStepTutorial()
        this.setDataStepTutorial(data.Respuesta)
      }
    }
  },
  computed: {
    // Deshabilita next step en el paso 3 en caso de no tener al menos un certificado cargado
    enableStepSedeJudicial () {
      // return true
      return this.dataWizard?.idPaqueteContratacion === 3
    },
    activeStepStepper () {
      if (!this.enableStepSedeJudicial && this.activeStep > 2) return this.activeStep - 2
      return this.activeStep - 1
    },
    enableNextStep () {
      return !this.desactiveNextStep && !(this.activeStep === 4 && !this.dataCertificates[0]?.fechaCaducidad) && this.activeStep !== 1
    },
    listaSteps () {
      return this.dataWizard?.ListaSteps || []
    },
    desactiveBackStep () {
      return this.activeStep <= 1
    },
    desactiveNextStep () {
      return this.lastStep <= this.activeStep
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    labelBackStep () {
      return this.$t('wizard.back_step')
    },
    labelValidate () {
      return this.$t('app.validate') 
    },
    labelNextStep () {
      return this.$t('wizard.next_step')
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    logo: function () {
      if (this.darkMode) {
        return 'edasneowhite.webp'
      }
      return 'edasneo.webp'
    },
    sedesJudicialesForAccessibleSelect () {
      return this.sedesJudiciales.map(item => ({
        id: item.id,
        name: item.name,
        value: item.id
      }))
    },
  },
  methods: {
    /// Style
    resetScroll () {
      setTimeout(() => {
        document
          .getElementById('container-steps')
          .scrollTo({ top: 0, behavior: 'smooth' })
      }, 100)
    },
    /// Control steps and dialog
    onClickAddForm () {
      this.showNextForm = true
    },
    showButtonNextForm (key) {
      // if (key === 2 && this.formStepCertificados?.certificadosCIFs?.length > 2) return false
      if (key === 2 && this.dataCertificates[2].fechaCaducidad) return false
      return key !== 0 && this.dataCertificates?.length <= (key + 1) && !this.showNextForm
    },
    toggleDialog: async function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    backStep () {
      if (this.desactiveBackStep) return
      // Si no es el paquete de sede judicial nos saltamos el paso de elección de sede judicial
      if (!this.enableStepSedeJudicial && this.activeStep === 4) this.activeStep = this.activeStep - 2
      else this.activeStep = this.activeStep - 1

      this.resetScroll()
    },
    nextStep () {
      if (this.desactiveNextStep) return
      if (this.activeStep === 1) this.submitValidStepInicial()
      else if (this.activeStep === 2) this.submitValidStepDescargaAutomatica()
      else if (this.activeStep === 3) this.submitValidStepSedeJudicial()
      else if (this.activeStep === 4) this.submitValidStepCerts()
      else if (this.activeStep === 5) this.submitValidStepTutorial()
    },
    finishStep: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await updateStepWizard({ idPasoActual: 6 })
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleDialog()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    logout () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
      this.$emit('toggleDialogClose')
      this.$store.dispatch('auth/logout')
    },
    // Call handlers
    submitValidStepInicial: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await updateStepWizard({ idPasoActual: 1 })
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.activeStep = this.activeStep + 1
          this.resetScroll()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    submitValidStepDescargaAutomatica: async function () {
      this.$refs.ruleformStepDescargaAutomatica.validate(async valid => {
        if (valid) {
          try {
            this.$store.commit('setIsLoading', true)
            const payload = {
              DescargaAutomatica: this.formStepDescargaAutomatica.DescargaAutomatica,
              DiasDescargaAutomatica: this.formStepDescargaAutomatica.DiasDescargaAutomatica,
            }
            const response = await updateDescargaAutomaticaWizard(payload)
            if (response.blnError) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Datos actualizados correctamente', 'success')
              // Si no es el paquete de sede judicial nos saltamos el paso de elección de sede judicial
              if (this.enableStepSedeJudicial) this.activeStep = this.activeStep + 1
              else this.activeStep = this.activeStep + 2
              this.resetScroll()
            }
          } catch (error) {
            this.doFeedback()
          } finally {
            this.$store.commit('setIsLoading', false)
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
    submitValidStepSedeJudicial: async function () {
      this.$refs.ruleformStepSedeJudicial.validate(async valid => {
        if (valid) {
          try {
            this.$store.commit('setIsLoading', true)
            const payload = {
              idSedeJudicial: this.formStepSedeJudicial.idSedeJudicial,
            }
            const response = await updateSedeJudicialWizard(payload)
            if (response.blnError) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.doFeedback('Datos actualizados correctamente', 'success')
              this.activeStep = this.activeStep + 1
              this.resetScroll()
            }
          } catch (error) {
            this.doFeedback()
          } finally {
            this.$store.commit('setIsLoading', false)
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
    // Validacion de los certificados en el Step 3
    nextStepValidate (key) {
      this.rulesStepCertificados = this.rulesStepCertificadosCert
      setTimeout(() => {
        this.$refs.ruleformStepCertificados.validate(async valid => {
          if (valid) {
            try {
              this.$store.commit('setIsLoading', true)
              const payload = { base64: '', pwd: '' }
              payload.base64 = this.files[key].b64
              payload.name = this.files[key].name
              payload.pwd = this.formStepCertificados.certificadosCIFs[key].password

              const response = await getPfxData(payload)
              if (response.blnError) {
                this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
              } else {
                this.setDataStepCerts(response.datosCertificadoCIF, key)

                // Initialize next
                this.showNextForm = false
                this.initializeNext()
              }
            } catch (error) {
              this.doFeedback()
            } finally {
              this.$store.commit('setIsLoading', false)
            }
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      }, 500)
    },
    // Inicializacion del siguiente certificado
    initializeNext () {
      // En caso de ser el ultimo no añadimos mas
      if (this.formStepCertificados?.certificadosCIFs?.length > 2) return
      this.formStepCertificados.certificadosCIFs.push({
        password: null,
        file: '',
        NombreCIF: '',
        CIF: '',
      })

      this.files.push({
        name: '',
        b64: ''
      })
      this.dataCertificates.push({
        serial: '',
        issuer: '',
        nombre: '',
        fechaCaducidad: ''
      })
    },
    // Limpiamos step 3 
    cleanDataStepCerts () {
      this.formStepCertificados = { certificadosCIFs: [] }
      this.files = []
      this.dataCertificates = []
    },
    // Añadidmos datos vacios a step 3
    pushDataStepCerts () {
      this.formStepCertificados.certificadosCIFs.push({
        password: null,
        file: '',
        NombreCIF: '',
        CIF: '',
      })
      
      this.files.push({
        name: '',
        b64: ''
      })

      this.dataCertificates.push({
        serial: '',
        issuer: '',
        nombre: '',
        fechaCaducidad: ''
      })
    },
    // Eliminamos el certificado y empresa elegido
    removeByKey (key) {
      // Controlamos si esta lleno y usado 
      let isFull = false
      if (this.dataCertificates?.length === 3 && this.dataCertificates[2].fechaCaducidad) isFull = true

      // Eliminamos todo del index indiciado
      this.formStepCertificados.certificadosCIFs.splice(key, 1)
      this.files.splice(key, 1)
      this.dataCertificates.splice(key, 1)
      
      // En caso de quitar todos inicializamos uno 
      if (this.dataCertificates?.length === 0) {
        this.showNextForm = false
        this.initializeNext()
      }
      // En caso de lleno y usado tenemos que inicializar el ultimo y ocultarlo
      if (isFull) {
        this.initializeNext()
        this.showNextForm = false
      }
    },
    submitValidStepCerts: async function () {
      this.rulesStepCertificados = this.rulesStepCertificadosSubmit
      setTimeout(() => {
        this.$refs.ruleformStepCertificados.validate(async valid => {
          if (valid) {
            try {
              this.$store.commit('setIsLoading', true)
              const payload = []
              this.formStepCertificados.certificadosCIFs.filter(x => x.CIF).forEach((x, index) => {
                payload.push({})
                payload[index].password = x.password
                payload[index].file = x.file
                payload[index].NombreCIF = x.NombreCIF
                payload[index].CIF = x.CIF
              })
              this.dataCertificates.filter(x => x.serial).forEach((x, index) => {
                payload[index].serial = x.serial
              })
              const finalPayload = []
              payload.forEach(x => {
                finalPayload.push({
                  CIF: x.CIF,
                  RazonSocial: x.NombreCIF,
                  file: x.file,
                  password: x.password,
                  SerialNumber: x.file ? null : x.serial,
                })
              })

              const response = await uploadPfx(finalPayload)
              if (response.blnError) {
                this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
              } else {
                this.doFeedback('Datos actualizados correctamente', 'success')
                this.activeStep = this.activeStep + 1
                this.resetScroll()
              }
            } catch (error) {
              console.log(error)
              this.doFeedback()
            } finally {
              this.$store.commit('setIsLoading', false)
            }
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      }, 500)
    },
    submitValidStepTutorial: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await updateStepWizard({ idPasoActual: 5 })
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.activeStep = this.activeStep + 1
          this.resetScroll()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadDataStepDescargaAutomatica: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getCompanyTemplate()
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          return res
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    downloadDataStepDescargaAutomaticaSedesJudiciales: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getSedeJudicialWizard()
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          return res
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    downloadDataStepCerts: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getCertData()
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          return res
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    downloadDataStepTutorial: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await getVideoTutorial()
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          return res
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    // Setters
    setDataStepDescargaAutomatica: function (data) {
      if (data) {
        this.formStepDescargaAutomatica.DescargaAutomatica = data.DescargaAutomatica ? data.DescargaAutomatica : false
        this.formStepDescargaAutomatica.DiasDescargaAutomatica = data.DiasDescargaAutomatica ? data.DiasDescargaAutomatica : null
      }
    },
    setDataStepSedesJudiciales: function (data) {
      if (data) {
        this.formStepDescargaAutomatica.idSedeJudicial = data.idSedeJudicial ? data.idSedeJudicial : false
      }
    },
    setDataStepCerts: function (data, key) {
      if (data) {
        this.dataCertificates[key].serial = data?.datosCertificadoVinculado?.SerialNumber ? data?.datosCertificadoVinculado?.SerialNumber : null 
        this.dataCertificates[key].issuer = data?.Emisor ? data?.Emisor : null 
        this.dataCertificates[key].nombre = data?.datosCertificadoVinculado?.CommonName ? data?.datosCertificadoVinculado?.CommonName : null
        this.dataCertificates[key].fechaCaducidad = data?.datosCertificadoVinculado?.ExpirationDate ? moment(data?.datosCertificadoVinculado?.ExpirationDate).format('DD-MM-yyyy HH:mm') : null
        this.formStepCertificados.certificadosCIFs[key].NombreCIF = data?.RazonSocial ? data?.RazonSocial : null
        this.formStepCertificados.certificadosCIFs[key].CIF = data?.CIF ? data?.CIF : null
      }
    },
    setDataStepTutorial: function (data) {
      if (data) {
        this.videoIdLink = data
      }
    },
    resetCertForm (key) {
      this.removeByKey(key)
    },
    // Validations
    isNextPreloadAvailable (key) {
      if (key === 0) return true
      if (key > 2) return false
      return this.dataCertificates[key - 1]?.fechaCaducidad
    },
    checkPreloadCert (key) {
      return this.dataCertificates[key]?.fechaCaducidad
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    isPhoneValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (value.length !== 9 || !isPhoneValid(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.phone.length_numbers'), callback)
      } else {
        callback()
      }
    },
    isDayValidDownload: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDayDownload(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso_download'), callback)
      } else {
        callback()
      }
    },
    handleChange: function (file, key) {
      this.getBase64(file.raw).then(res => {
        const b64 = res.split(',')
        this.files[key].b64 = b64[1]
        this.formStepCertificados.certificadosCIFs[key].file = this.files[key].b64
      })
      this.files[key].name = file.name
    },
  }
}
</script>

